module.exports = __webpack_public_path__ + "static/evergreen-table-basic-f64eba0d4636e6583e59330d7456ba74.png";